import React from 'react';
import { motion } from 'framer-motion';
import { content } from '../data/content';
import { PaintStroke } from './PaintStroke';
export function Process() {
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-166">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl font-bold text-brand-brown mb-6 relative inline-block" data-id="element-167">
            <PaintStroke className="absolute -bottom-4 left-0 w-full h-6 text-brand-amber opacity-30 -z-10" data-id="element-168" />
            {content.process.heading}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-brown/80" data-id="element-169">
            {content.process.subhead}
          </motion.p>
        </div>

        <div className="relative" data-id="element-170">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-1 bg-brand-tan/20" data-id="element-171">
            <motion.div className="h-full bg-brand-orange" initial={{
            width: '0%'
          }} whileInView={{
            width: '100%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} data-id="element-172" />
          </div>

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-0 bottom-0 left-8 w-1 bg-brand-tan/20" data-id="element-173">
            <motion.div className="w-full bg-brand-orange" initial={{
            height: '0%'
          }} whileInView={{
            height: '100%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} data-id="element-174" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-175">
            {content.process.steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.3
          }} className="relative flex md:flex-col items-start md:items-center text-left md:text-center" data-id="element-176">
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-brand-cream border-4 border-white shadow-lg flex items-center justify-center font-display text-2xl font-bold text-brand-orange mb-0 md:mb-6 z-10 relative" data-id="element-177">
                  {index + 1}
                </div>
                <div className="ml-6 md:ml-0 mt-2 md:mt-0" data-id="element-178">
                  <h3 className="font-display text-xl font-bold text-brand-brown mb-3" data-id="element-179">
                    {step.title}
                  </h3>
                  <p className="text-brand-brown/80" data-id="element-180">{step.description}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}